export const ASSETS = {
  logo: "https://customer-assets-39nsmqrw.emergentagent.net/job_moda-circular-br/artifacts/2m99b80a_logo.png",
  hero: "https://customer-assets-39nsmqrw.emergentagent.net/job_moda-circular-br/artifacts/by0aobqa_IMG_4259.JPG%20%281%29.jpeg",
  phone: "https://customer-assets.emergentagent.com/job_17e2afaa-bdad-476f-8063-027bc4cd683a/artifacts/fvvh4q0m_IMG-0660.webp",
  rack: "https://customer-assets.emergentagent.com/job_17e2afaa-bdad-476f-8063-027bc4cd683a/artifacts/o0rckm6q_IMG-0622.webp",
  hangers: "https://customer-assets.emergentagent.com/job_17e2afaa-bdad-476f-8063-027bc4cd683a/artifacts/fwrw6r37_IMG-0590.webp",
  reviews: "https://customer-assets.emergentagent.com/job_moda-circular-br/artifacts/a44dhcoc_IMG-0595.webp",
  portrait: "https://customer-assets.emergentagent.com/job_17e2afaa-bdad-476f-8063-027bc4cd683a/artifacts/huo9b2v0_IMG-0648.webp",
};

export const CONTACT = {
  whatsapp: "https://api.whatsapp.com/send/?phone=5541995850433&text&type=phone_number&app_absent=0&utm_source=site",
  instagram: "https://www.instagram.com/desapeguecomherida/",
  reel: "https://www.instagram.com/reel/CvFgGdOgK9u/",
  tour: "https://www.instagram.com/stories/highlights/18093249136682546/",
  aoVivo: "https://www.instagram.com/stories/highlights/18406768690064458/",
  feedback: "https://www.instagram.com/stories/highlights/18002190806229257/",
  liveShop: "https://www.instagram.com/stories/highlights/17921317559860513/",
  decor: "https://www.instagram.com/stories/highlights/17867665137591108/",
  googleReviews: "https://www.google.com/search?q=desapegue+com+herida#lrd=0x94dce30150aa42f7:0x89f71d4abd140ab4,1,,,,",
  maps: "https://www.google.com/maps/search/?api=1&query=Rua+Marcelino+Champanhat+280+Merc%C3%AAs+Curitiba+PR",
  address: {
    street: "Rua Marcelino Champanhat, 280",
    neighborhood: "Mercês",
    city: "Curitiba — PR",
  },
  city: "Curitiba — PR",
  phone: "+55 41 99585-0433",
  handle: "@desapeguecomherida",
};
